import request from '@/utils/zsm-requets'
const file = '/zsm/api/file/'
/**
 * 新增媒体
 *
 * @params bizId 	  类型id 如版权传课程id
 * @params bizClassFirst 	  素材默认是100
 * @params bizClassSec 素材二级分类
 * @params cover 封面
 * @params title 标题
 * @params cloudDict 默认'aliyun'
 * @params url 媒体地址
 * @params frontId 前端用户id
 * @params bizId bizId
 */
export function createFile(info) {
  return request({
    url: file + 'create',
    method: 'post',
    params: info
  })
}


/* 删除素材  */
export function deleteFile(id) {
  return request({
    url: file + 'delete',
    method: 'post',
    params: { id }
  })
}

/* 查看单个素材  */
export function getFile(params) {
  return request({
    url: file + 'get',
    method: 'post',
    params
  })
}


/* 查看素材列表  */
export function listDataFile(params) {
  return request({
    url: file + 'listData',
    method: 'post',
    params
  })
}

/* 修改素材  */
export function updateFile(params) {
  return request({
    url: file + 'update',
    method: 'post',
    params
  })
}

// 素材替换
export function deleteAndCreate(params) {
  return request({
    url: file + 'deleteAndCreate',
    method: 'post',
    params
  })
}


/**
 * 分组查询
 * @param {String} loginCode 讲师账号 
 * @param {String} name 分组标题   
 * @param {String} classType 分组类型 
 * @param {Number} pageNo pageNo
 * @param {Number} pageSize pageSize
 * @returns 
 */
export function findFileGroup(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: file + 'findFileGroup',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 删除分组
 * @param {String} id 分组Id 
 * @returns 
 */
export function delFileGroup(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: file + 'delFileGroup',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 修改分组
 * @param {String} id 分组Id 
 * @param {String} name 分组名称 
 * @param {String} sort 排序 
 * @param {String} classType 分组类型 
 * @returns 
 */
export function updateFileGroup(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: file + 'updateFileGroup',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 创建分组
 * @param {String} id 分组Id 
 * @param {String} name 分组名称 
 * @param {String} sort 排序 
 * @param {String} classType 分组类型 
 * @returns 
 */
export function createFileGroup(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: file + 'createFileGroup',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}



/**
 * 批量修改素材分组
 * @param {String} fileIds 素材id
 * @param {String} fileGroupCode 分组Id 
 * @returns 
 */
export function updateFileGroupCodeById(params) {
  return request({
    url: file + 'updateFileGroupCodeById',
    method: 'post',
    params
  })
}


/**
 * 批量删除素材
 * @param {String} fileIds 素材id
 * @param {String} flag 0删 1查
 * @returns 
 */
export function delFileByIds(params) {
  return request({
    url: file + 'delFileByIds',
    method: 'post',
    params
  })
}
